import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import Select from "react-select";
import { FormGroup, Label, Input } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { get } from '../../../../../utils/helpers/api';
import SelectCustomStyles from '../../../../../utils/styles/reactSelect';
import { useTranslation } from 'react-i18next';

const EMPTY_FILTERS = {
  subject: '',
  priority: '',
  assigned_to: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});
  const [employeesData, setEmployeesData] = useState([]);
  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      initData();
    }
  }, [isOpen]);

  const initData = async () => {
    setInitLoading(true);
    const data = await get('/crm/tasks/create');
    if (data.success) {
      setEmployeesData(data.employees);
      setInitLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.subject')}: </Label>
          <Input
            value={filtersData.subject}
            onChange={(e) => setFiltersData({...filtersData, subject: e.target.value})}
          />
        </FormGroup>

        <FormGroup>
          <Label>{t('crm.priority')} </Label>
          <Input
            type="select"
            value={filtersData.priority}
            onChange={(e) => setFiltersData({...filtersData, priority: e.target.value})}
          >
            <option value="">{t('common.selectPriority')}</option>
            <option value="low">{t('common.low')}</option>
            <option value="normal">{t('common.normal')}</option>
            <option value="high">{t('common.high')}</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label>{t('crm.assignedTo')} </Label>
          <Select
            options={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname }))}
            styles={SelectCustomStyles}
            value={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname })).find(o => o.value === filtersData.assigned_to) || null}
            onChange={selected => setFiltersData({ ...filtersData, assigned_to: selected ? selected.value : null })}
          />
        </FormGroup>

        <hr />

        <FormGroup>
          <Label>{t('common.addedAfter')} </Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')} </Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.applyFilters')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.clearFilters')}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;